export const dateToLocalFormat = (date) => new Date(date).toLocaleDateString("uk-UA")